<template>
	<div class="page">
		<site-header :headerMenu="headerMenu" v-on:updateMenus="updateMenus"></site-header>		
		<transition name="page-content">	
			<div v-if="!loading && chapters" class="content-wrapper">
				<default-page v-bind:pageTitle="pageTitle" v-bind:content="content"></default-page>
				<download-center-layout 
					:chapters="chapters" 
					:full_report="full_report"></download-center-layout>
			</div>
		</transition>
		<transition :name="transitionName">	
			<div v-if="loading" :class="['loading-overlay', 'has-spinner', 'transition', {'wavy-bg': customTransitionInProgress}]">
				<spinner color="white" size="large"></spinner>
			</div>
		</transition>
		<transition name="cover-and-swipe" :duration="{ enter: 450, leave: 650 }">
			<div v-if="pageLoading" :class="['page-cover', 'has-spinner', 'transition']">
				<spinner color="white" size="large"></spinner>
			</div>
		</transition>
		<transition name="fade">	
			<site-footer v-if="!loading && !pageLoading" v-bind:data="footer"></site-footer>
		</transition>
	</div>
</template>

<script>
import BasePageLayout from './BasePageLayout'
import SiteHeader from '../components/global/Header'
import SiteFooter from '../components/global/Footer'
import DownloadCenterLayout from '../components/blocks/DownloadCenterLayout'

export default {
	extends: BasePageLayout,
	name: 'download-center',
	props: ['lang', 'postType', 'slug'],
	data() {
		return {
			chapters: false,
			full_report: false
		}
	},
	components: {
		SiteHeader: SiteHeader,
		SiteFooter: SiteFooter,
		DefaultPage: () => import('../components/pages/Default'),
		DownloadCenterLayout: DownloadCenterLayout,
		Spinner: () => import('../components/ruter/Spinner'),
	},
	methods: {
		loadAdditionalData(data) {
			if (typeof data.post.chapters !== 'undefined') {
				this.chapters = data.post.chapters
			}
			if (typeof data.post.full_report !== 'undefined') {
				this.full_report = data.post.full_report
			}
		},
		clearAdditionalData() {
			this.chapters = false
			this.full_report = false
		},
	},
	created() {
		this.getGlobalSiteData()
		this.getData()
	}
}
</script>